<template>
  <Navbar></Navbar>
  <router-view/>
</template>

<script>
import Navbar from "./views/Navbar";
import store from "./store";

export default {
  components: {Navbar},
  mounted() {
    store.dispatch('retrieveFromLocalStorage');
    store.dispatch('getStudents');
  }
}
</script>

<style>
@import "~bulma/css/bulma.css";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
